import React from "react";
import "./about-us.scss";
import "./about-us_.scss";
import ButtonVerMas from "../../components/ButtonVerMas";
import CounterSection from "../../components/CounterSection";

export default function AboutUs() {

    ////////////////////////////////////////////////
    return (
        <div className="container-about-us">
            <div className="cuadro"></div>
            <div className="ingeniero">
                <div></div>
            </div>

            <div className="historia">
                <h1>IMAD</h1>
                <p>Ingenieria </p>
                <p>Manufactura <br />Digital 3D</p>
                <p>y Servicios S.A.C.</p>
                <p>Somos una empresa especializada en desarrollar proyectos de ingeniería altamente innovadores, satisfaciendo las necesidades de nuestros clientes y cumpliendo con las exigencias de diseño empleando las normas internacionales que nos avalan.
                </p>
            </div>

            <div className="container-iconos">
                <CounterSection number='1' name='SOBRE NOSOTROS' />
            </div>

        </div>
    );
}

